import { Injectable } from "@angular/core";
import { BasicError } from "projects/shared/lib/error/basic-error";
import { ProductService } from "projects/shared/lib/services/data/product/product.service";
import {
  EError,
  ProductOrderPriceGetItemDto, ProductOrderPriceGetQueryResult, ProductPriceInfoGetItemDto,
  ProductPriceInfoGetQueryResult
} from "projects/shared/lib/services/INTEGRA_Shop_Client";
import { Observable, of, Subscription } from "rxjs";
import { ENVIRONMENT } from "projects/shared/lib/environment/environment";
import { ErrorCodeService } from "projects/shared/lib/services/infrastructure/error-code.service";

@Injectable({
  providedIn: 'root'
})
export class ProductMHService extends ProductService {

  private permissionSubscription: Subscription | undefined;

  public constructor() {
    super();

    this.permissionSubscriptionInit();
  }

  private permissionSubscriptionInit() {
    if (!this.permissionSubscription) {
      this.permissionSubscription = this.authService.userPermissionChangedGet().subscribe(
        () => {
          this.shouldLoadPrices = this.shouldLoadPricesCurrentStateGet();
        }
      );
    }
  }

  protected shouldLoadPricesCurrentStateGet(): boolean {
    return ENVIRONMENT.price.allowAnonymousPrice || (this.authService.isAuthenticated() && this.authService?.canSeePrices());
  }

  public productOrderPriceGet(productList?: ProductOrderPriceGetItemDto[] | undefined): Observable<ProductOrderPriceGetQueryResult> {
    if (!this.shouldLoadPrices) {
      this.logger.error("Tried to load prices in service though they aren't allowed.", this.constructor.name);
      throw new BasicError("Illegal access", ErrorCodeService.formatErrorCode(EError.F290011));
    }

    if (productList == undefined || productList.length <= 0) {
      return of(new ProductOrderPriceGetQueryResult());
    }

    productList.forEach(
      (product) => {
        product.priceDate = this.cartDeliveryDate;
      }
    );
    let addressNumber: number | undefined = this.cartDeliveryAddress?.integraCustomerAddressNumber;


    return this.productApiService.productOrderPriceGet(productList, addressNumber);
  }

  public productPriceInfoGet(productList?: ProductPriceInfoGetItemDto[] | undefined): Observable<ProductPriceInfoGetQueryResult> {
    if (!this.shouldLoadPrices) {
      this.logger.error("Tried to load price informations in service though they aren't allowed.", this.constructor.name);
      throw new BasicError("Illegal access", ErrorCodeService.formatErrorCode(EError.F290021));
    }

    if (productList == undefined || productList.length <= 0) {
      return of(new ProductPriceInfoGetQueryResult());
    }

    let requestDate = new Date(Date.now());
    if (this.cartDeliveryDate != undefined) {
      requestDate = this.cartDeliveryDate;
    }
    requestDate.setHours(12, 0, 0, 0);
    requestDate.setUTCHours(12, 0, 0, 0);

    this.logger.info(`productPriceInfoGet; requestDate: ${requestDate}`, this.constructor.name);

    productList.forEach(
      (product) => {
        // product.priceDate = this.cartDeliveryDate;
        product.priceDate = requestDate;
      }
    );
    let addressNumber: number | undefined = this.cartDeliveryAddress?.integraCustomerAddressNumber;
    return this.productApiService.productPriceInfoGet(productList, addressNumber);
  }

}
